import * as React from 'react'
import { Input } from 'cs-kevlar-react'

interface CustomizableInputProps {
  defaultValue?: string
  errorRegEx?: RegExp | undefined
  name: string
  onChange?: (event: any) => void
  readOnly?: boolean
  required?: boolean | undefined
  showLabel?: boolean
  type?: string
}

export const CustomizableInput: React.FunctionComponent<CustomizableInputProps> = ({
  defaultValue = '',
  errorRegEx = null,
  name,
  onChange = () => {},
  readOnly = false,
  required = false,
  showLabel = false,
  type = 'text'
}) => {
  const [validationMessage, setValidationMessage] = React.useState('')

  const handleChange = (value: any) => {
    onChange(value)

  if (required && (value.target.value == null || value.target.value == ''))
    setValidationMessage(name + ' is required')
  else if (errorRegEx && !errorRegEx.test(value.target.value))
    setValidationMessage(name + ' is invalid')
  else
    setValidationMessage('')
  }

  return (
    <React.Fragment>
      {showLabel && 
        <label style={{ color: "gray" }}>
          {name}
          <Input 
            type={type}
            defaultValue={defaultValue}
            onChange={(event)=> {handleChange(event)}}
            fullWidth={true}
            readOnly={readOnly}
            required={required} />
        </label>
      }
      {!showLabel && 
        <Input 
          type={type}
          defaultValue={defaultValue}
          onChange={(event)=> {handleChange(event)}}
          fullWidth={true}
          readOnly={readOnly}
          required={required} />
      }
      {(required || errorRegEx) && 
        <span style={{ color: "red", fontSize: "small" }}>{validationMessage}</span>
      }
    </React.Fragment>
  )
}
